import { atom, selector } from "recoil";
import {
	userHasAccessToCareerHubState,
	userHasAccessToCareerOptionsState,
	userHasAccessToJobSearchState,
	userHasAccessToLearningHubState, userHasAccessToSkillsLibrary,
} from "../../account/states/UserStates";
import produce from "immer";
import { findIndex } from "lodash";

export const headerNavigationItems = {
	"Career Options": {
		href: "/career-options/",
		iconName: "favourite-careers",
		assessmentsRequired: true,
	},
	"Learning Hub": {
		href: "/learn/",
		iconName: "courses",
	},
	"Career Advice Hub": {
		href: "/career-hub/",
		iconName: "resources",
	},
	"Job Search": {
		href: "/jobs/",
		iconName: "jobs",
	},
};

export const personalNavigationItems = [
	{
		icon: "favourite-careers",
		label: "My Favourite Careers",
		href: "/career-options/favourites/",
	},
	{
		icon: "super-powers",
		label: "My Superpowers",
		href: "/profile/my-superpowers/",
	},
	{
		icon: "resources",
		label: "My Resources",
		href: "/career-hub/bookmarks/",
	},
];

export const headerNavigationByPlanState = selector({
	key: "headerNavigationByPlan",
	get: ({get}) => {
		return produce(headerNavigationItems, draft => {
			if (!get(userHasAccessToCareerOptionsState)) {
				delete draft["Career Options"];
			}
			if (!get(userHasAccessToJobSearchState)) {
				delete draft["Job Search"];
			}
			if (!get(userHasAccessToLearningHubState)) {
				delete draft["Learning Hub"];
			}
			if (!get(userHasAccessToCareerHubState)) {
				delete draft["Career Advice Hub"];
			}
		});
	}
});

export const personalNavigationByPlanState = selector({
	key: "personalNavigationByPlan",
	get: ({get}) => {
		return produce(personalNavigationItems, draft => {
			if (!get(userHasAccessToCareerOptionsState)) {
				draft.splice(findIndex(draft, {label: "My Favourite Careers"}), 1);
			}
			if (!get(userHasAccessToCareerHubState)) {
				draft.splice(findIndex(draft, {label: "My Resources"}), 1);
			}
			if (!get(userHasAccessToSkillsLibrary)) {
				draft.splice(findIndex(draft, {label: "My Superpowers"}), 1);
			}
		});
	}
});

export const headerVisibleState = atom({
	key: "headerVisible",
	default: true,
});

export const headerMobileNavigationOpenState = atom({
	key: "headerMobileNavigtationOpen",
	default: false,
});

export const userNavigationOpenState = atom({
	key: "userNavigationOpen",
	default: false,
});

export const mySpaceOpenState = atom({
	key: "mySpaceOpen",
	default: false,
});

export const mySpaceHiddenState = atom({
	key: "mySpaceHidden",
	default: false,
});

export const personalNavigationHidden = atom({
	key: "personalNavigationHidden",
	default: false,
});

export const intercomOpenState = atom({
	key: "intercomOpen",
	default: false,
});
